/* Marcel Afters: SKIMS pass (24 Sep 2026).
   1. Card colour dots: hover (mouse) previews that colour's own image; tap/click chooses it and points the
      card's links at that colour. Tapping the chosen dot again clears it.
   2. PDP "Size guide" opens the Size & Fit panel in place.
   3. PDP "Pairs with" arrows.
   Everything is delegated, so cards added by filters or infinite scroll work without re-binding. */
(function () {
  function closestCard(el) { return el.closest('product-card') || el.closest('.product-card'); }
  function mainImg(card) {
    var slide = card.querySelector('.card-gallery slideshow-slide');
    return (slide && slide.querySelector('img')) || card.querySelector('.card-gallery img');
  }
  // Same photo/flat tagging as ma-motion.js, re-run because the image source changes.
  function tag(img) {
    function set() {
      if (!img.naturalWidth) return;
      var src = img.currentSrc || img.src;
      var art = /artcard|hero-card/i.test(src) || (img.naturalWidth === img.naturalHeight && img.naturalWidth >= 1800);
      var ph = !art && (img.naturalHeight / img.naturalWidth > 1.05 || /\.jpe?g/i.test(src));
      img.classList.toggle('ma-photo', ph);
      img.classList.toggle('ma-art', art);
      img.classList.toggle('ma-wide', ph && img.naturalWidth / img.naturalHeight > 1.25);
    }
    if (img.complete && img.naturalWidth) set(); else img.addEventListener('load', set, { once: true });
  }
  function show(dot) {
    var card = closestCard(dot); if (!card || !dot.dataset.img) return;
    var img = mainImg(card); if (!img) return;
    if (!('maOrig' in img.dataset)) {
      img.dataset.maOrig = img.getAttribute('src') || '';
      img.dataset.maOrigSet = img.getAttribute('srcset') || '';
      img.dataset.maOrigClass = img.className;
    }
    if (img.getAttribute('src') === dot.dataset.img) return;
    img.removeAttribute('loading');
    img.srcset = dot.dataset.srcset || '';
    img.src = dot.dataset.img;
    tag(img);
  }
  function restore(card) {
    var img = mainImg(card); if (!img || !('maOrig' in img.dataset)) return;
    var chosen = card.querySelector('.ma-sw__dot[aria-pressed="true"]');
    if (chosen && chosen.dataset.img) { show(chosen); return; }
    img.srcset = img.dataset.maOrigSet;
    img.src = img.dataset.maOrig;
    img.className = img.dataset.maOrigClass;
  }
  function choose(dot) {
    var card = closestCard(dot), group = dot.closest('.ma-sw');
    var was = dot.getAttribute('aria-pressed') === 'true';
    [].forEach.call(group.querySelectorAll('.ma-sw__dot'), function (d) { d.setAttribute('aria-pressed', 'false'); });
    if (!was) {
      dot.setAttribute('aria-pressed', 'true');
      show(dot);
      // Bring the card back to its first image so the chosen colour is what shows (phones flip to the graphic on scroll).
      var ss = card && card.querySelector('.card-gallery slideshow-component');
      if (ss && typeof ss.select === 'function') { try { ss.select(0, undefined, { animate: false }); } catch (err) {} }
      if (card && typeof card.applyVariantToLinks === 'function' && dot.dataset.variant) card.applyVariantToLinks(dot.dataset.variant);
    } else if (card) {
      restore(card);
      if (typeof card.applyVariantToLinks === 'function') card.applyVariantToLinks(null);
    }
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var dot = e.target.closest('.ma-sw__dot'); if (dot) show(dot);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var group = e.target.closest('.ma-sw'); if (!group) return;
    if (e.relatedTarget && group.contains(e.relatedTarget)) return;
    var card = closestCard(group); if (card) restore(card);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var dot = e.target.closest('.ma-sw__dot');
    if (dot) { e.preventDefault(); choose(dot); return; }

    var guide = e.target.closest('[data-ma-size-guide]');
    if (guide) {
      var panel = null;
      [].forEach.call(document.querySelectorAll('.ma-acc details'), function (d) {
        var s = d.querySelector('summary');
        if (!panel && s && /size/i.test(s.textContent)) panel = d;
      });
      if (panel) {
        e.preventDefault();
        panel.open = true;
        panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }

    var btn = e.target.closest('.ma-pairs__btn');
    if (btn) {
      var track = btn.closest('.ma-pairs').querySelector('[data-ma-pairs]');
      if (track) track.scrollBy({ left: track.clientWidth * 0.8 * Number(btn.dataset.dir || 1), behavior: 'smooth' });
    }
  });

  // Pairs with: hide the arrows when all four already fit, grey out the end you are at.
  function armPairs() {
    // A piece shows once per page: later rails drop anything an earlier rail already shows.
    var seen = {};
    [].forEach.call(document.querySelectorAll('.ma-pairs'), function (box) {
      [].forEach.call(box.querySelectorAll('.ma-pairs__item'), function (li) {
        var a = li.querySelector('a'), href = a && a.getAttribute('href');
        if (!href) return;
        if (seen[href]) li.remove(); else seen[href] = 1;
      });
      if (!box.querySelector('.ma-pairs__item')) box.hidden = true;
    });
    [].forEach.call(document.querySelectorAll('.ma-pairs'), function (box) {
      var track = box.querySelector('[data-ma-pairs]'); if (!track || track.dataset.maArmed) return;
      track.dataset.maArmed = '1';
      var prev = box.querySelector('[data-dir="-1"]'), next = box.querySelector('[data-dir="1"]');
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        box.classList.toggle('is-static', max < 4);
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armPairs); else armPairs();
})();
